import { observer } from "mobx-react";
import React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

import { NAVIGATION_MENU, isLocationAvailable } from "@client/utils/Constants";
import Style from "@client/utils/Style";

import backgroundImage from "./images/background.png";
import menuImage from "./images/menu";
import { TokenInfo } from "@typings/Identity";

const Wrapper = styled.div`
  margin-right: 38px;
  margin-left: 32px;
`;
const Close = css`
  transform: rotate(0deg) translateX(0) translateY(0);
`;
const Stub = styled.div`
  width: 20px;
`;
const Menu = styled.div<{ open: boolean }>`
  width: 160px;
  position: absolute;
  left: ${props => (props.open ? 0 : -160)}px;
  top: 64px;
  bottom: 0;
  background: url("${backgroundImage}") center bottom no-repeat;
  background-size: cover;
  transition: all ${Style.animations.swift};
`;
const MenuImage = styled.div<{ open: boolean }>`
  cursor: pointer;
  width: 20px;
  height: 20px;
  ${props =>
    props.open
      ? css`
          position: fixed;
        `
      : ""}
  top: 23px;
  z-index: 99;
  #top {
    ${props =>
      props.open
        ? css`
            transform: rotate(45deg) translateX(0.5px) translateY(-4.5px);
          `
        : Close}
    transition: all ${Style.animations.swift};
  }
  #bottom {
    ${props =>
      props.open
        ? css`
            transform: rotate(-45deg) translateX(-6.5px) translateY(1.5px);
          `
        : Close}
    transition: all ${Style.animations.swift};
  }
`;
const MenuItems = styled.div`
  display: flex;
  margin-top: 48px;
  margin-left: 24px;
  flex-direction: column;
  width: 140px;
`;
const MenuItem = styled(Link)`
  text-decoration: white;
  color: white;
  font-size: 18px;
  margin-top: 26px;
  &:first-child {
    margin-top: 0;
  }
`;

type State = {
  open: boolean;
};
type Props = {
  tokenInfo: TokenInfo | null;
};
@observer
class NavigationMini extends React.Component<Props, State> {
  state = { open: false };

  handleMenuToggleClick() {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <Wrapper>
        <MenuImage
          open={this.state.open}
          onClick={() => {
            this.handleMenuToggleClick();
          }}
          dangerouslySetInnerHTML={{ __html: menuImage() }}
        />
        {this.state.open ? <Stub /> : null}
        <Menu open={this.state.open}>
          <MenuItems>
            {NAVIGATION_MENU.map(menuItem =>
              isLocationAvailable(menuItem.location, this.props.tokenInfo) ? (
                <MenuItem key={menuItem.location} to={menuItem.location}>
                  {menuItem.label}
                </MenuItem>
              ) : null,
            )}
          </MenuItems>
        </Menu>
      </Wrapper>
    );
  }
}

export default NavigationMini;
